/*eslint-disable*/export const messages=JSON.parse("{\"mobility-recommendations-title\":\"Anbefalinger til deg\"}");